import {
  CallStatus,
  StatusType,
} from '../pages/batch-calls/CallManagementTabs/utils/const';

export type CallTaskDetail = {
  contactName: string;
  phoneNumber: string;
  dateTime: string;
  retryAt: string;
  duration: string;
  voiceMailLeft: 'Yes' | 'No';
  status: CallStatus;
  statusType: StatusType;
  recordings: boolean;
  recordingId?: string;
  transcript: boolean;
  details: boolean;
};

export const getMassOutreachTasks = (payload: any) => {
  return {
    content: [
      {
        task_id: 'qweqwd',
        createdAt: '2022-01-01T00:00:00.000Z',
        createdBy: 'John Doe',
        status: 'Completed',
        contactsCount: 10,
        taskName: 'Call Task',
      },
      {
        task_id: 'qweqwd',
        createdAt: '2022-01-01T00:00:00.000Z',
        createdBy: 'John Doe',
        status: 'Completed',
        contactsCount: 10,
        taskName: 'Call Task',
      },
      {
        task_id: 'qweqwd',
        createdAt: '2022-01-01T00:00:00.000Z',
        createdBy: 'John Doe',
        status: 'Completed',
        contactsCount: 10,
        taskName: 'Call Task',
      },
      {
        task_id: 'qweqwd',
        createdAt: '2022-01-01T00:00:00.000Z',
        createdBy: 'John Doe',
        status: 'Completed',
        contactsCount: 10,
        taskName: 'Call Task',
      },
      {
        task_id: 'qweqwd',
        createdAt: '2022-01-01T00:00:00.000Z',
        createdBy: 'John Doe',
        status: 'Completed',
        contactsCount: 10,
        taskName: 'Call Task',
      },
      {
        task_id: 'qweqwd',
        createdAt: '2022-01-01T00:00:00.000Z',
        createdBy: 'John Doe',
        status: 'Completed',
        contactsCount: 10,
        taskName: 'Call Task',
      },
    ],
  };
};
export const getCallTaskDetailsById = (payload: any) => {
  return {
    content: [
      {
        contactName: 'Mark Jensen',
        phoneNumber: '+491234567890',
        dateTime: '2022-01-01T00:00:00.000Z',
        retryAt: '00:00:00',
        duration: '2 min',
        voiceMailLeft: 'Yes',
        status: CallStatus.HAD_CONVERSATION,
        statusType: StatusType.SUCCESS,
        recordings: true,
        transcript: true,
        details: true,
      },
      {
        contactName: 'Andea Broccoli',
        phoneNumber: '+491234567890',
        dateTime: '2022-01-01T00:00:00.000Z',
        retryAt: '12:23:44',
        duration: '3 sec',
        voiceMailLeft: 'No',
        status: CallStatus.NOT_REACHED,
        statusType: StatusType.ERROR,
        recordings: true,
        transcript: true,
        details: true,
      },
      {
        contactName: 'Mark Jensen',
        phoneNumber: '+491234567890',
        dateTime: '2022-01-01T00:00:00.000Z',
        retryAt: '--:--:--',
        duration: '-',
        voiceMailLeft: 'No',
        status: CallStatus.DIALING,
        statusType: StatusType.INFO,
        recordings: true,
        transcript: true,
        details: true,
      },
      {
        contactName: 'Andea Broccoli',
        phoneNumber: '+491234567890',
        dateTime: '2022-01-01T00:00:00.000Z',
        retryAt: '00:00:44',
        duration: '16 sec',
        voiceMailLeft: 'No',
        status: CallStatus.CURRENTLY_TALKING,
        statusType: StatusType.INFO,
        recordings: true,
        transcript: true,
        details: true,
      },
      {
        contactName: 'Mark Jensen',
        phoneNumber: '+491234567890',
        dateTime: '2022-01-01T00:00:00.000Z',
        retryAt: '00:00:16',
        duration: '2 min',
        voiceMailLeft: 'Yes',
        status: CallStatus.HAD_CONVERSATION,
        statusType: StatusType.SUCCESS,
        recordings: true,
        transcript: true,
        details: true,
      },
      {
        contactName: 'Mark Jensen',
        phoneNumber: '+491234567890',
        dateTime: '2022-01-01T00:00:00.000Z',
        retryAt: '-',
        duration: '-',
        voiceMailLeft: 'Yes',
        status: CallStatus.CALL_SCHEDULED,
        statusType: StatusType.NEUTRAL,
        recordings: true,
        transcript: true,
        details: true,
      },
      {
        contactName: 'Andea Broccoli',
        phoneNumber: '+491234567890',
        dateTime: '2022-01-01T00:00:00.000Z',
        retryAt: '-',
        duration: '-',
        voiceMailLeft: 'Yes',
        status: CallStatus.NOT_REACHED,
        statusType: StatusType.ERROR,
        recordings: true,
        transcript: true,
        details: true,
      },
    ],
  };
};
